import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import Store from 'store/store';
import { flightList } from 'helpers/airportData.js';
import s from 'components/bolt/airport/popUpWindows/boardingTimes/boardingTimes.sss';

export default class BoardingTimes extends Component {

	onFlightClick(e, flight) {
		e?.stopPropagation();
		if (flight.status === 'noFly' || flight.status === 'delayed') {
			Store.emit('ROB_UPDATE', 'boardingTimes_routeClosed');
		} else {
			let eventCategory = flight.planet ? 'planet-overlay' : flight.easterEgg ? 'video' : flight.upWorld ? 'up-world' : undefined;
			Store.emit('CUSTOM_EVENT', {
				category: eventCategory,
				action: 'boarding-times-click',
				label: flight.id
			});

			if (flight.upWorld) {
				Store.emit('SCROLL_TO_UPWORLD');
			} else {
				this.props.toggleWindow(flight.id);
			}
		}
	}

	render({ section, imageRoot }) {
		const popUpCopy = section.popUp?.copy;

		return (
			<div class={s.scroller}>
				<div
					class={s.content}
					onMouseDown={(e) => e.stopPropagation()}
					onTouchStart={(e) => e.stopPropagation()}
				>
					<div class={s.intro}>
						<HTML
							class={s.introText}
							content={popUpCopy?.subtitle}
							markdown
						/>
					</div>
					<div class={s.flightListContainer}>
						{flightList.map(flight => {
							const flightStatusIconSrc = flight.status === 'noFly' ? `${imageRoot}/airport/i9y3nd-red.webp` : flight.status === 'delayed' ? `${imageRoot}/airport/i9y3nd-yellow.webp` : `${imageRoot}/airport/i9y3nd.webp`;
							const flightStatus = flight.status === 'noFly' ? popUpCopy.noFlightZone : flight.status === 'delayed' ? popUpCopy.delayed : popUpCopy.boardingNow;
							return (
								<div class={s.flight} key={`${flight.id}-flight`} onClick={(e) => this.onFlightClick(e, flight)} role="button" id={flight.status == 'boarding' && 'clickable'}>
									<div
										class={s.flightInfo}
									>
										<img class={s.flightIcon} src={`${imageRoot}/airport/${flight.icon}`} alt={flight.logoAlt} />
										<span class={s.flightName}>{flight.name}</span>
										<span class={s.flightStatus}>{flightStatus}</span>
									</div>
									<img class={s.flightStatusIcon} src={flightStatusIconSrc} />
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}	